<template>
  <div class="tools-partners-invites-received">
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <!-- desktop area -->
      <snow-data-table :columns="columns" :data="invitesReceived">
        <template #no-content-actions>
          <div class="bg-2 rounded-16 p-4 d-flex gap-3">
            <i class="ph ph-clock-countdown fs-32" />
            <div class="d-flex flex-column gap-1">
              <h6 class="text-semibold">Receber um convite</h6>
              <h6 class="text-dark-40">
                Aguarde ser convidado para ajudar a administrar um novo negócio
              </h6>
            </div>
          </div>
        </template>
      </snow-data-table>
      <div v-if="!loading" class="d-flex justify-content-end mt-4">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      page: 1,
      pagination: { count: 0 }
    };
  },
  computed: {
    ...mapState("partnersCenter", ["invitesReceived"]),
    columns() {
      return [
        {
          name: "Empresa",
          field: "company",
          transform: company => company.name
        },
        {
          name: "Status",
          field: "status",
          transform: (_, item) => {
            if (item.accepted_at) return "Aprovado";
            if (item.rejected_at) return "Rejeitado";
            return "Pendente";
          },
          class: (_, item) => {
            if (item.accepted_at) return "active-badge";
            if (item.rejected_at) return "inactive-badge";
            return "draft-badge";
          }
        },
        {
          type: "menu",
          options: this.actions
        }
      ];
    }
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    status(item) {
      if (item.accepted_at)
        return "<strong class='text-success'>APROVADO</strong>";
      if (item.rejected_at)
        return "<strong class='text-danger'>REJEITADO</strong>";
      return "<strong class='text-secondary'>PENDENTE</strong>";
    },
    dispatch(offset = null) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/getMyInvites", { offset })
        .then(({ count, next, previous }) => {
          this.pagination = { count, next, previous };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    actions(item) {
      if (item.accepted_at || item.rejected_at) return [];
      return [
        {
          label: "Aceitar",
          dialog: {
            text: "Tem certeza de que deseja aceitar o convite?",
            icon: "ph ph-check-circle",
            buttonText: "Sim, aceitar",
            action: this.accept,
            secondaryButtonText: "Não, cancelar"
          }
        },
        {
          label: "Rejeitar",
          dialog: {
            text: "Tem certeza de que deseja rejeitar o convite?",
            icon: "ph ph-prohibit",
            buttonText: "Sim, rejeitar",
            action: this.reject,
            secondaryButtonText: "Não, cancelar"
          }
        }
      ];
    },
    statusBadge(item) {
      if (item.accepted_at) return "active-badge";
      if (item.rejected_at) return "inactive-badge";
      return "draft-badge";
    },
    accept(item) {
      this.update(item.code, true);
    },
    reject(item) {
      this.update(item.code, false);
    },
    update(code, to_accept) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/putMyInvite", { code, to_accept })
        .then(() => {
          this.dispatch();
          this.$store.dispatch("postLogin");
        })
        .catch(() => {
          this.$message.error("Erro");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
